import { render, staticRenderFns } from "./MediaBookDetail.vue?vue&type=template&id=426cd978&"
import script from "./MediaBookDetail.vue?vue&type=script&lang=js&"
export * from "./MediaBookDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports